var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import each from 'lodash/each';
import sortBy from 'lodash/sortBy';
import CompanyStore from 'stores/CompanyStore/store';
import AllExpectations from '../shared/expectations/AllExpectations';
import PersonalExpectations from '../shared/expectations/Expectations';
function getStateFromStores() {
    var data = CompanyStore.getCompanyInfo();
    return data;
}
var Expectations = /** @class */ (function (_super) {
    __extends(Expectations, _super);
    function Expectations(props) {
        var _this = _super.call(this, props) || this;
        _this.state = getStateFromStores();
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        return _this;
    }
    Expectations.prototype.componentDidMount = function () {
        CompanyStore.addChangeListener(this.onChangeHandler);
    };
    Expectations.prototype.componentWillUnmount = function () {
        CompanyStore.removeChangeListener(this.onChangeHandler);
    };
    Expectations.prototype.onChangeHandler = function () {
        this.setState(getStateFromStores());
    };
    Expectations.prototype.getPersonalExpectations = function () {
        var userId = parseInt(String(this.state.current_user.id), 10);
        var goals = this.state.goals
            .filter(function (goal) { return parseInt(String(goal.user_id), 10) === userId; });
        var products = this.state.products.reduce(function (aggregate, product) {
            var _a;
            return __assign(__assign({}, aggregate), (_a = {}, _a[product.id] = product.product_name, _a));
        }, {});
        var expectations = [];
        var lowestPercentComplete = 0;
        each(goals, function (goal) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var activity = goal.activity;
            // Push quantity goal
            if (parseInt(String(goal.goal), 10) > 0) {
                var goalFrequency = parseInt(String(goal.goal_frequency), 10);
                expectations.push({
                    key: "".concat(goal.id, "-quantity"),
                    goal: parseInt(String(goal.goal), 10),
                    actual: parseInt(String(activity.quantity), 10),
                    frequency: goalFrequency,
                    isCurrency: false,
                    productName: products[goal.product_id],
                    percentComplete: Math.min(1, parseInt(String(activity.quantity), 10) / parseInt(String(goal.goal), 10))
                });
            }
            // Push value goal
            if (parseInt(String(goal.value_goal), 10) > 0) {
                var valueGoalFrequency = parseInt(String(goal.value_goal_frequency), 10);
                expectations.push({
                    key: "".concat(goal.id, "-value"),
                    goal: parseInt(String(goal.value_goal), 10),
                    actual: parseInt(String(activity.value), 10),
                    frequency: valueGoalFrequency,
                    isCurrency: true,
                    productName: products[goal.product_id],
                    percentComplete: Math.min(1, parseInt(String(activity.value), 10) / parseInt(String(goal.value_goal), 10))
                });
            }
        });
        expectations = sortBy(expectations, function (expectation) {
            return expectation.percentComplete;
        });
        if (expectations[0]) {
            lowestPercentComplete = expectations[0].percentComplete * 100;
        }
        return (_jsx(PersonalExpectations, { isCoachsArea: false, expectations: expectations, lowestPercentComplete: lowestPercentComplete }, "Personal"));
    };
    Expectations.prototype.getAllExpectations = function () {
        var result = '';
        if (this.state.account.public_expectations) {
            result = (_jsx(AllExpectations, {}));
        }
        return result;
    };
    Expectations.prototype.render = function () {
        return (_jsxs("div", { className: "sb-app-main", children: [_jsx("h1", { className: "activity-heading", children: "Expectations" }), _jsxs("div", { className: "scorecard-expectations", children: [this.getPersonalExpectations(), this.getAllExpectations()] })] }));
    };
    return Expectations;
}(React.Component));
export default Expectations;
